import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Button, Col, Form, Modal } from 'react-bootstrap';
import dayjs from 'dayjs';
import InputGroup from 'react-bootstrap/InputGroup';
import DatePicker from 'react-datepicker';

import { ApiServiceServerless } from '../../xhr_libs';
import { DateOptions } from '../../pages/Reports/ReportHelpers';




function AdvancedDashboardModal(props) {
  const { organization_id, dashboardRefreshOption, setDashboardRefreshOption, setDashboardRefreshFlag, show, onHide, showToast } = props;

  const [activeTab, setActiveTab] = useState('refresh-options');

  const [localRefreshOption, setLocalRefreshOption] = useState(dashboardRefreshOption);

  const [endDate, setEndDate] = useState();
  const [dateOffset, setDateOffset] = useState(1);
  const [dateOption, setDateOption] = useState(1);

  const [isLoading, setIsLoading] = useState(false);

  const handleRefresh = (localRefreshOption) => {
    setDashboardRefreshOption(localRefreshOption)
    setDashboardRefreshFlag((prev) => prev + 1);
    onHide();
  }

  const dashboardCacheRefresh = () => {
    let payload = { end_date: endDate, offset: dateOffset, date_option: dateOption }
    setIsLoading(true)
    ApiServiceServerless.post(
      `/dashboard/${organization_id}`,
      payload,
      { authorization_id: organization_id }
    )
      .catch((err) => {
        setIsLoading(false)
        showToast('danger', 'Error', err);
        throw err;
      }).finally(() => {
        showToast('success', 'Success', 'Dashboard Cache is being refreshed. Please check back in a few minutes.');
        setIsLoading(false);
        onHide();
      })
  }


  useEffect(() => {
    let end_date = dayjs.utc();
    setEndDate(end_date);

  }, [organization_id]);

  return (
    <>
      <Modal show={show} onHide={onHide} >
        <Modal.Header closeButton style={{ height: '50px' }}>
          Advanced Dashboard Options
        </Modal.Header>
        <Modal.Body
          style={{
            overflowY: 'auto',
            maxHeight: '65vh',
            marginBottom: '10px',

          }}
        >
          <Tabs
            id='advanced-dashboard-tabs'
            activeKey={activeTab}
            onSelect={(e) => setActiveTab(e)}
            className='et-main-tabs'
          ><Tab eventKey='refresh-options' title={'Refresh Options'}>
              <Form.Group as={Col} md={'sm'}>
                <Form.Label >Dashboard Caching Retreive Option</Form.Label>
                <Form.Control
                  as='select'
                  onChange={(e) => setLocalRefreshOption(parseInt(e.target.value))}
                  value={localRefreshOption}
                >

                  <option key={'0'} value={0}>
                    Use Available Cahce
                  </option>
                  <option key={'0'} value={1}>
                    Fetch New Data
                  </option>

                </Form.Control>
              </Form.Group>
              <Button style={{ 'float': 'right' }} onClick={() => handleRefresh(localRefreshOption)} disabled={isLoading}> Refresh Dashboard</Button>
            </Tab>
            <Tab eventKey='dashboard-caching' title={'Dashboard Caching'}>

              <Col>
                <Form.Row>
                  <Form.Group>
                    <Form.Label>End date</Form.Label>
                    <InputGroup size='sm' className='et-AD-date-select' >
                      <DatePicker
                        selected={
                          endDate ? new Date(endDate) : new Date()
                        }
                        dateFormat='MM/yyyy'
                        onChange={(date) => setEndDate(date)}
                        showMonthYearPicker
                        showTwoColumnMonthYearPicker

                      />
                    </InputGroup>
                  </Form.Group>
                </Form.Row>
                <Form.Row>

                  <Form.Group>
                    <Form.Label>Date Option</Form.Label>
                    <Form.Control
                      as='select'
                      onChange={(e) => setDateOption(e.target.value)}
                      value={dateOption}
                      style={{ 'width': '250px' }}
                    >
                      {Object.keys(DateOptions).map((option) => (
                        <option key={`unit-opt-${option}`} value={option}>
                          {DateOptions[option]}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group>
                    <Form.Label>Month Count</Form.Label>
                    <Form.Control
                      as='select'
                      onChange={(e) => setDateOffset(parseInt(e.target.value))}
                      value={dateOffset}
                      style={{ 'width': '250px' }}
                    >
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((option) => (
                        <option key={`unit-opt-${option}`} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>


                </Form.Row>
                <Button style={{ 'float': 'right' }} onClick={() => dashboardCacheRefresh(localRefreshOption)} disabled={isLoading}> Refresh Dashboard Cache</Button>
              </Col>


            </Tab>

          </Tabs>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default AdvancedDashboardModal;
